import { render, staticRenderFns } from "./SelectorSteps.vue?vue&type=template&id=6a8215ba"
import script from "./SelectorSteps.vue?vue&type=script&lang=js"
export * from "./SelectorSteps.vue?vue&type=script&lang=js"
import style0 from "./SelectorSteps.vue?vue&type=style&index=0&id=6a8215ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorSheet: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Error/ErrorSheet.vue').default})
